import { store, read, remove } from "./LocalStorage";

/** Read Token
 * @return string
 */
export const readToken = () => {
  return read("token");
};

/** Read Refresh Token
 * @return string
 */
export const readRefreshToken = () => {
  return read("refreshToken");
};

/** Store Token and RefreshToken
 * @param token
 * @param refreshToken
 * @param {boolean} rememberMe
 */
export const storeToken = (token, refreshToken, rememberMe = true) => {
  if (!rememberMe) {
    store("token", token, window.sessionStorage);
    store("refreshToken", refreshToken, window.sessionStorage);
    return;
  }
  store("token", token);
  store("refreshToken", refreshToken);
};

/** Remove Token & refreshToken*/
export const removeToken = () => {
  remove("token") ||
    remove("token", window.sessionStorage) ||
    remove("refreshToken") ||
    remove("refreshToken", window.sessionStorage);
};
